import i18n from 'i18next';
import { hasEnabledFeature } from 'globalutils/fmUtils';
import { checkServiceProvider } from './serviceProviderConfig';

const findTimeFromMinutes = (minutes) => {
  let hr = Math.floor(minutes / 60);
  let actualHr = hr ? (hr > 12 ? hr - 12 : hr) : '12';
  let min = minutes % 60;
  min = min > 9 ? min : `0${min}`;
  return `${actualHr}:${min}${hr >= 12 && hr != 24 ? 'pm' : 'am'}`;
};

export const resetDataList = ({ source, dailyLogDetails }) => {
  let result = [];
  for (let i = 0; i < source.length; i++) {
    const element = source[i];
    if (i % 2 === 0) {
      delete element.noEdit;
      result[result.length] = {
        status: element.status.label,
        note: element.note || null,
        stateModifier:
          element?.stateModifier !== null && element?.stateModifier?.value !== 'please'
            ? element?.stateModifier?.label || null
            : null,
        oilFieldWaiting:
          element?.stateModifier !== null &&
          element?.stateModifier?.value !== 'please' &&
          hasEnabledFeature('editOilFieldWaitingEnabled') &&
          dailyLogDetails?.originalData?.enableEditOW === true
            ? true
            : false,
        location: element.location || null,
        driverId: parseInt(element?.driverId?.value, 10) || null,
        time_from: element.time,
        eldData: element.eldData,
        time_to: source[i + 1].time,
        readOnly: element.readOnly,
        minutes_to: element.minutes_to >= 1440 ? element.minutes_to : findMinutesFromTime(source[i + 1].time),
        minutes_from: element.minutes_from >= 1440 ? element.minutes_from : findMinutesFromTime(element.time),
      };
    }
  }
  if (result.length) result[result.length - 1].minutes_to = 1440;
  result.sort((a, b) => {
    return a.minutes_to - b.minutes_to;
  });
  result.forEach((ele, index) => {
    if (index == 0) {
      ele.minutes_from = 0;
    }
    if (result[index + 1]) {
      result[index + 1].minutes_from = ele.minutes_to;
    }
    ele.time_from = findTimeFromMinutes(ele.minutes_from);
    ele.time_to = findTimeFromMinutes(ele.minutes_to);
  });
  return result;
};

const removeUnwantedPoints = ({ list, editingArea }) => {
  let result = [];
  for (let index = 0; index < list.length; index++) {
    const element = list[index];
    if (element.x > editingArea.lx && element.x < editingArea.rx) {
    } else {
      result.push(element);
    }
  }
  return result;
};

const checkProvider = (currentStatusValue) => {
  const isOW = currentStatusValue?.value === 'OW';

  if (isOW) {
    return {
      label: checkServiceProvider('checkServiceProvider_isOW_label', window.$environment.SERVICE_PROVIDER, false),
      value: 'OW',
    };
  }

  return {
    label: 'No',
    value: 'please',
  };
};

//Get the value of a key from a list based on other key value
export const getObjectKeyValue = (source, key, value, requiredField) => {
  for (let index = 0; index < source.length; index++) {
    const element = source[index];
    if (element[key] === value) {
      return element[requiredField];
    }
  }
};

export const getStatusFromPoint = ({ value, yData }) => {
  const label = getObjectKeyValue(yData, 'value', value, 'label');
  return {
    label,
    value,
  };
};

const getPrevPoint = ({ list, editingArea }) => {
  for (let index = 0; index < list.length; index++) {
    const element = list[index];
    if (element.x < editingArea.rx) {
      return list[index + 1];
    }
  }
};

const getNextPoint = ({ list, editingArea }) => {
  for (let index = 0; index < list.length; index++) {
    const element = list[index];
    if (element.x > editingArea.rx) {
      return list[index - 1];
    }
  }
};

export const findMinutesFromTime = (time) => {
  if (time) {
    const hrs = parseInt(time.split(':')[0], 10);

    const minutes = parseInt(time.split(':')[1].substring(0, 2), 10);
    const timeIn24 = time.includes('pm') > 0 && hrs != 12 ? hrs + 12 : time === '12:00am' ? 0 : hrs;
    return timeIn24 * 60 + minutes;
  } else {
    return 0;
  }
};

export const getNewGraphPoints = ({
  editingArea,
  editedDataList,
  selectedRow,
  yValues,
  providerMode,
  yData,
  dailyLogDetails,
  setDailyLogEntries,
}) => {
  let temp = [...editedDataList];
  const currentStartingPoint = temp[selectedRow ? selectedRow * 2 : 0];
  currentStartingPoint.minutes_to =
    currentStartingPoint.minutes_to > 1440 ? currentStartingPoint.minutes_to : findMinutesFromTime(editingArea.ltime);
  const currentFinishingPoint = temp[selectedRow ? selectedRow * 2 + 1 : 1];
  if (editingArea.ltime === '12:00am' && editingArea.rtime === '12:00am') {
    temp = [];

    temp.push({
      ...currentStartingPoint,
      time: editingArea.ltime,
      x: editingArea.lx,
    });
    temp.push({
      ...currentFinishingPoint,
      time: editingArea.rtime,
      x: editingArea.rx,
    });
  } else {
    const nextToLastPoint = getNextPoint({ list: temp, editingArea });
    const prevToFirstPoint = getPrevPoint({ list: temp, editingArea });

    const currentStatusValue = getStatusFromPoint({ value: getObjectKeyValue(yValues, 'y', editingArea.ly + 3, 'key'), yData });
    const currentStatus = currentStatusValue?.value === 'OW' ? { label: i18n.t('OFF_DUTY'), value: 'OFF' } : currentStatusValue;
    const currentStateModifier = checkProvider(currentStatusValue);
    const currentOilFieldWaiting = currentStatusValue?.value === 'OW' ? true : false;

    let firstNewPoint = {
      ...currentStartingPoint,
      time: editingArea.ltime,
      x: editingArea.lx,
      minutes_to:
        currentStartingPoint.minutes_to > 1440 ? currentStartingPoint.minutes_to : findMinutesFromTime(editingArea.ltime),
    };
    let secondNewPoint = {
      ...firstNewPoint,
      time: editingArea.ltime,
      x: editingArea.lx,
      status: currentStatus,
      stateModifier: currentStateModifier,
      oilFieldWaiting: currentOilFieldWaiting,
      y: editingArea.ly,
    };
    let lastNewPoint = {
      ...currentFinishingPoint,
      time: editingArea.rtime,
      x: editingArea.rx,
      status: currentFinishingPoint.status,
      stateModifier: currentFinishingPoint.stateModifier,
      oilFieldWaiting: currentFinishingPoint.oilFieldWaiting,
      y: currentFinishingPoint.y,
    };
    let secondLastNewPoint = {
      ...currentFinishingPoint,
      time: editingArea.rtime,
      x: editingArea.rx,
      status: currentStatus,
      stateModifier: currentStateModifier,
      oilFieldWaiting: currentOilFieldWaiting,

      y: editingArea.ly,
    };

    if (currentStartingPoint.x !== firstNewPoint.x && currentFinishingPoint.x !== lastNewPoint.x) {
      //Change in both x, change in y
      firstNewPoint = {
        ...firstNewPoint,
        time: editingArea.ltime,
        x: editingArea.lx,
        status: prevToFirstPoint ? prevToFirstPoint.status : firstNewPoint.status,
        stateModifier: prevToFirstPoint ? prevToFirstPoint.stateModifier : firstNewPoint.stateModifier,
        oilFieldWaiting: prevToFirstPoint ? prevToFirstPoint.oilFieldWaiting : firstNewPoint.oilFieldWaiting,

        y: prevToFirstPoint ? prevToFirstPoint.y : firstNewPoint.y,
      };

      secondNewPoint = {
        ...secondNewPoint,
        status: currentStatus,
        stateModifier: currentStateModifier,
        oilFieldWaiting: currentOilFieldWaiting,

        y: editingArea.ly,
      };
      temp.splice(selectedRow ? selectedRow * 2 + 1 : 1, 0, firstNewPoint);
      temp.splice(selectedRow ? selectedRow * 2 + 2 : 2, 0, secondNewPoint);

      secondLastNewPoint = {
        ...secondLastNewPoint,
        status: currentStatus,
        stateModifier: currentStateModifier,
        oilFieldWaiting: currentOilFieldWaiting,

        y: editingArea.ly,
      };

      temp.splice(selectedRow ? selectedRow * 2 + 3 : 3, 0, secondLastNewPoint);

      lastNewPoint = {
        ...lastNewPoint,
        time: editingArea.rtime,
        x: editingArea.rx,
        status: nextToLastPoint ? nextToLastPoint.status : lastNewPoint.status,
        eldData: nextToLastPoint ? nextToLastPoint.eldData : lastNewPoint.eldData,
        ...(providerMode
          ? {
              location: nextToLastPoint ? nextToLastPoint.location : lastNewPoint.location,
              note: nextToLastPoint ? nextToLastPoint.note : lastNewPoint.note,
              readOnly: nextToLastPoint ? nextToLastPoint.readOnly : lastNewPoint.readOnly,
            }
          : {}),
        stateModifier: nextToLastPoint ? nextToLastPoint.stateModifier : lastNewPoint.stateModifier,
        oilFieldWaiting: nextToLastPoint ? nextToLastPoint.oilFieldWaiting : lastNewPoint.oilFieldWaiting,
        y: nextToLastPoint ? nextToLastPoint.y : lastNewPoint.y,
      };
      temp.splice(selectedRow ? selectedRow * 2 + 4 : 4, 0, lastNewPoint);
    } else if (
      currentStartingPoint.x === firstNewPoint.x &&
      currentFinishingPoint.x === lastNewPoint.x &&
      firstNewPoint.y === lastNewPoint.y
    ) {
      //No change in x. but y may get changed
      firstNewPoint = {
        ...firstNewPoint,
        status: currentStatus,
        stateModifier: currentStateModifier,
        oilFieldWaiting: currentOilFieldWaiting,
        y: editingArea.ly,
      };
      lastNewPoint = {
        ...lastNewPoint,
        status: currentStatus,
        stateModifier: currentStateModifier,
        oilFieldWaiting: currentOilFieldWaiting,
        y: editingArea.ly,
      };
      temp[selectedRow ? selectedRow * 2 : 0] = firstNewPoint;
      temp[selectedRow ? selectedRow * 2 + 1 : 1] = lastNewPoint;
    } else if (currentStartingPoint.x === firstNewPoint.x && currentFinishingPoint.x !== lastNewPoint.x) {
      //No change in lx. y or rx is changed
      firstNewPoint = {
        ...firstNewPoint,
        status: currentStatus,
        stateModifier: currentStateModifier,
        oilFieldWaiting: currentOilFieldWaiting,
        y: editingArea.ly,
      };
      secondLastNewPoint = {
        ...secondLastNewPoint,
        status: currentStatus,
        stateModifier: currentStateModifier,
        oilFieldWaiting: currentOilFieldWaiting,
        y: editingArea.ly,
      };

      temp[selectedRow ? selectedRow * 2 : 0] = firstNewPoint;
      temp.splice(selectedRow ? selectedRow * 2 + 1 : 1, 0, secondLastNewPoint);

      lastNewPoint = {
        ...lastNewPoint,
        time: editingArea.rtime,
        x: editingArea.rx,
        status: nextToLastPoint ? nextToLastPoint.status : lastNewPoint.status,
        eldData: nextToLastPoint ? nextToLastPoint.eldData : lastNewPoint.eldData,
        ...(providerMode
          ? {
              location: nextToLastPoint ? nextToLastPoint.location : lastNewPoint.location,
              note: nextToLastPoint ? nextToLastPoint.note : lastNewPoint.note,
              readOnly: nextToLastPoint ? nextToLastPoint.readOnly : lastNewPoint.readOnly,
            }
          : {}),
        stateModifier: nextToLastPoint ? nextToLastPoint.stateModifier : lastNewPoint.stateModifier,
        oilFieldWaiting: nextToLastPoint ? nextToLastPoint.oilFieldWaiting : lastNewPoint.oilFieldWaiting,
        y: nextToLastPoint ? nextToLastPoint.y : lastNewPoint.y,
      };
      temp.splice(selectedRow ? selectedRow * 2 + 2 : 2, 0, lastNewPoint);
    } else if (currentStartingPoint.x !== firstNewPoint.x && currentFinishingPoint.x === lastNewPoint.x) {
      //No change in rx. y or lx is changed
      firstNewPoint = {
        ...firstNewPoint,
        time: editingArea.ltime,
        x: editingArea.lx,
        status: prevToFirstPoint ? prevToFirstPoint.status : firstNewPoint.status,
        stateModifier: prevToFirstPoint ? prevToFirstPoint.stateModifier : firstNewPoint.stateModifier,

        oilFieldWaiting: prevToFirstPoint ? prevToFirstPoint.oilFieldWaiting : firstNewPoint.oilFieldWaiting,
        y: prevToFirstPoint ? prevToFirstPoint.y : firstNewPoint.y,
      };

      secondNewPoint = {
        ...secondNewPoint,
        status: currentStatus,
        stateModifier: currentStateModifier,
        oilFieldWaiting: currentOilFieldWaiting,
        y: editingArea.ly,
      };
      secondLastNewPoint = {
        ...secondLastNewPoint,
        status: currentStatus,
        stateModifier: currentStateModifier,
        oilFieldWaiting: currentOilFieldWaiting,
        y: editingArea.ly,
      };
      temp[selectedRow ? selectedRow * 2 + 1 : 1] = firstNewPoint;
      temp.splice(selectedRow ? selectedRow * 2 + 2 : 2, 0, secondNewPoint);
      temp.splice(selectedRow ? selectedRow * 2 + 3 : 3, 0, secondLastNewPoint);
      temp[selectedRow ? selectedRow * 2 + 3 : 3] = lastNewPoint;
    }

    temp = removeUnwantedPoints({ list: temp, editingArea });
  }

  const result = resetDataList({ source: [...temp], dailyLogDetails });
  result[result.length - 1].minutes_to = 1440;
  setDailyLogEntries({
    data: [...result],
    asArray: true,
  });
};
